import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "reference-ids-form"
  }, [_vm._t("header"), _vm.hasNoEntries ? _c(VRow, [_c(VCol, {
    class: ['text-left', _vm.classVerticalSpace],
    attrs: {
      "cols": "12"
    }
  }, [_c('core-button', {
    attrs: {
      "data-cy": "btn_add_reference_id",
      "title": _vm.$i18n_t('Common.addNew'),
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.addEntry
    }
  })], 1)], 1) : _vm._e(), _vm._l(_vm.referenceIdPairs, function (entry, index) {
    return _c(VRow, {
      key: `entry_${index}`
    }, [_c(VCol, {
      class: _vm.classVerticalSpace,
      attrs: {
        "cols": _vm.singleColumn ? 12 : null
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `input_key_${index}_${Object.keys(entry)[0]}`,
        "value": _vm.entryKey(index),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.keyLabel,
        "hide-details": "",
        "disabled": _vm.disabled,
        "dense": _vm.dense,
        "rules": [_vm.validateKey]
      },
      on: {
        "input": function ($event) {
          return _vm.updateKey(index, $event);
        }
      }
    })], 1), _c(VCol, {
      class: _vm.classVerticalSpace,
      attrs: {
        "cols": _vm.singleColumn ? 12 : null
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `input_value_${index}_${Object.keys(entry)[0]}`,
        "value": _vm.entryValue(index),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.valueLabel,
        "hide-details": "",
        "disabled": _vm.disabled,
        "dense": _vm.dense,
        "rules": [v => _vm.validateValue(v, index)]
      },
      on: {
        "input": function ($event) {
          return _vm.updateValue(index, $event);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c('core-button', {
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "data-cy": `btn_add_reference_id_${index}`,
        "title": _vm.$i18n_t('Common.addNew'),
        "color": _vm.color,
        "prepend-icon": "fa-plus",
        "disabled": _vm.disabled,
        "x-small": _vm.dense
      },
      on: {
        "click": function ($event) {
          return _vm.addEntry(index);
        }
      }
    }), _c('core-button', {
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "data-cy": "btn_delete_reference_id",
        "title": _vm.$i18n_t('Common.delete'),
        "color": _vm.color,
        "prepend-icon": "fa-trash-alt",
        "disabled": _vm.disabled,
        "x-small": _vm.dense
      },
      on: {
        "click": function ($event) {
          return _vm.removeEntry(index);
        }
      }
    })], 1)], 1);
  })], 2)])], 1), _vm.type === 'virtualDevice' ? _c(VRow, {
    staticClass: "mt-6"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.addressedDTs')))]), _c('p', {
    staticClass: "card-description my-0 mb-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.addressedDescription')) + "\n      ")]), _c(VDataTable, {
    staticClass: "elevation-1 reference-table",
    attrs: {
      "headers": _vm.linkedTwinHeaders,
      "items": _vm.linkedReferenceIds,
      "loading": _vm.loading,
      "no-data-text": _vm.$i18n_t('Common.noResults'),
      "fixed-header": "",
      "dense": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "header.name",
      fn: function () {
        return [_c('div', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(_vm.linkedTwinHeaders[0].text))])];
      },
      proxy: true
    }, {
      key: "header.value",
      fn: function () {
        return [_c('div', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(_vm.linkedTwinHeaders[1].text))])];
      },
      proxy: true
    }, {
      key: "header.linkedTwins",
      fn: function () {
        return [_c('div', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(_vm.linkedTwinHeaders[2].text))])];
      },
      proxy: true
    }, {
      key: "header.actions",
      fn: function ({}) {
        return [_c('div', {
          staticClass: "text-end"
        }, [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "loading": _vm.loading,
            "disabled": _vm.linkedReferenceIds.length === 0,
            "title": _vm.$i18n_t('Common.refresh'),
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.refreshAllLinkedTwins
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fal fa-sync")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.updateList')) + "\n            ")], 1)], 1)];
      }
    }, {
      key: "item.name",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-start text-truncate px-4",
          staticStyle: {
            "max-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])];
      }
    }, {
      key: "item.value",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-start text-truncate px-4",
          staticStyle: {
            "max-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(item.value) + "\n          ")])];
      }
    }, {
      key: "item.linkedTwins",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "d-flex flex-wrap text-start px-4",
          staticStyle: {
            "align-items": "flex-start"
          }
        }, [_vm._l(item.linkedTwins, function (twin) {
          return _c(VChip, {
            key: twin.id,
            staticClass: "ma-1",
            staticStyle: {
              "max-width": "150px"
            },
            attrs: {
              "link": "",
              "to": `/digitaltwin-mgmt/${twin.id}`,
              "small": ""
            }
          }, [_c('span', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(twin.title || twin.id))])]);
        }), item.linkedTwins.length === 0 ? _c('span', {
          staticClass: "font-italic"
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.noLinkedTwins')) + "\n            ")]) : _vm._e()], 2)];
      }
    }], null, false, 1217162787)
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };